/* Buy-funnel events for the launch storefront.
   Publishes custom events on Shopify's analytics bus so the Customer events
   pixel (see docs/meta-custom-pixel.js) can forward them to Meta. Checkout,
   payment and purchase events come from Shopify itself, so only the steps
   before checkout are tracked here. */
(function () {
  'use strict';

  function publish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (err) { /* tracking must never break the page */ }
  }

  function placement(el) {
    if (el.closest('.nav')) return 'nav';
    if (el.closest('.dock')) return 'sticky_bar';
    if (el.closest('.ft')) return 'footer';
    var section = el.closest('section[id]');
    return section ? section.id : 'page';
  }

  // Every buy button, in the order the visitor meets them.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a.btn--buy, a.nav__buy');
    if (link) {
      var href = link.getAttribute('href') || '';
      publish('lx_buy_click', {
        location: placement(link),
        // false means the button only scrolled to #price because no product is live
        goes_to_checkout: href.indexOf('/cart/') === 0
      });
      return;
    }
    var library = event.target.closest && event.target.closest('a[data-lx-library]');
    if (library) publish('lx_library_click', { location: placement(library) });
  }, true);

  // Interest signal: the price block actually came into view (once per page).
  var price = document.getElementById('price');
  if (price && 'IntersectionObserver' in window) {
    var seen = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      seen.disconnect();
      publish('lx_price_view', {});
    }, { threshold: 0.4 });
    seen.observe(price);
  }

  // Thank-you page reached (proves delivery instructions were shown).
  if (document.querySelector('[data-lx-thanks]')) publish('lx_thankyou_view', {});
})();
